import styled from '@emotion/styled'

import { spacingSection } from '@/styles/mixins'
import { H2, Text2 } from '@/styles/typography'
import { mediaUp } from '@/styles/media'

export const Container = styled.section`
  ${spacingSection};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 0 80px;
`

export const Heading = styled(H2)`
  margin: 18px 0;

  ${mediaUp('md')} {
    margin: 40px 0;
  }
`

export const Info = styled(Text2)``

export const IconWrapper = styled.div`
  width: 42px;
  height: 42px;

  ${mediaUp('lg')} {
    width: 86px;
    height: 86px;
  }
`

export const HintsContainer = styled.div`
  max-width: 70%;
  justify-content: center;
  align-items: center;
`
